<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil bwlist" style="background:#fff;">
            <a-card title="收费时间间隔设置">
                <a-select v-model="hour" style="width: 120px" @change="changehouer">]
                    <a-select-option value="0">0</a-select-option>
                    <a-select-option value="1">1</a-select-option>
                    <a-select-option value="2">2</a-select-option>
                    <a-select-option value="3">3</a-select-option>
                    <a-select-option value="4">4</a-select-option>
                    <a-select-option value="5">5</a-select-option>
                    <a-select-option value="6">6</a-select-option>
                    <a-select-option value="7">7</a-select-option>
                    <a-select-option value="8">8</a-select-option>
                    <a-select-option value="9">9</a-select-option>
                    <a-select-option value="10">10</a-select-option>
                    <a-select-option value="11">11</a-select-option>
                    <a-select-option value="12">12</a-select-option>
                </a-select>
                <label for="" class="font">时</label>
                <a-select v-model="minue" style="width: 120px" @change="changeminue">
                    <a-select-option value="0">0</a-select-option>
                    <a-select-option value="1">1</a-select-option>
                    <a-select-option value="2">2</a-select-option>
                    <a-select-option value="3">3</a-select-option>
                    <a-select-option value="4">4</a-select-option>
                    <a-select-option value="5">5</a-select-option>
                    <a-select-option value="6">6</a-select-option>
                    <a-select-option value="7">7</a-select-option>
                    <a-select-option value="8">8</a-select-option>
                    <a-select-option value="9">9</a-select-option>
                    <a-select-option value="10">10</a-select-option>
                    <a-select-option value="11">11</a-select-option>
                    <a-select-option value="12">12</a-select-option>
                    <a-select-option value="13">13</a-select-option>
                    <a-select-option value="14">14</a-select-option>
                    <a-select-option value="15">15</a-select-option>
                    <a-select-option value="16">16</a-select-option>
                    <a-select-option value="17">17</a-select-option>
                    <a-select-option value="18">18</a-select-option>
                    <a-select-option value="19">19</a-select-option>
                    <a-select-option value="20">20</a-select-option>
                    <a-select-option value="21">21</a-select-option>
                    <a-select-option value="22">22</a-select-option>
                    <a-select-option value="23">23</a-select-option>
                    <a-select-option value="24">24</a-select-option>
                    <a-select-option value="25">25</a-select-option>
                    <a-select-option value="26">26</a-select-option>
                    <a-select-option value="27">27</a-select-option>
                    <a-select-option value="28">28</a-select-option>
                    <a-select-option value="29">29</a-select-option>
                    <a-select-option value="30">30</a-select-option>
                    <a-select-option value="31">31</a-select-option>
                    <a-select-option value="32">32</a-select-option>
                    <a-select-option value="33">33</a-select-option>
                    <a-select-option value="34">34</a-select-option>
                    <a-select-option value="35">35</a-select-option>
                    <a-select-option value="36">36</a-select-option>
                    <a-select-option value="37">37</a-select-option>
                    <a-select-option value="38">38</a-select-option>
                    <a-select-option value="39">39</a-select-option>
                    <a-select-option value="40">40</a-select-option>
                    <a-select-option value="41">41</a-select-option>
                    <a-select-option value="42">42</a-select-option>
                    <a-select-option value="43">43</a-select-option>
                    <a-select-option value="44">44</a-select-option>
                    <a-select-option value="45">45</a-select-option>
                    <a-select-option value="46">46</a-select-option>
                    <a-select-option value="47">47</a-select-option>
                    <a-select-option value="48">48</a-select-option>
                    <a-select-option value="49">49</a-select-option>
                    <a-select-option value="50">50</a-select-option>
                    <a-select-option value="51">51</a-select-option>
                    <a-select-option value="52">52</a-select-option>
                    <a-select-option value="53">53</a-select-option>
                    <a-select-option value="54">54</a-select-option>
                    <a-select-option value="55">55</a-select-option>
                    <a-select-option value="56">56</a-select-option>
                    <a-select-option value="57">57</a-select-option>
                    <a-select-option value="58">58</a-select-option>
                    <a-select-option value="59">59</a-select-option>
                </a-select>
                <label for="" class="font">分</label>

                <a-select v-model="second" style="width: 120px" @change="changesecond">
                    <a-select-option value="0">0</a-select-option>
                    <a-select-option value="1">1</a-select-option>
                    <a-select-option value="2">2</a-select-option>
                    <a-select-option value="3">3</a-select-option>
                    <a-select-option value="4">4</a-select-option>
                    <a-select-option value="5">5</a-select-option>
                    <a-select-option value="6">6</a-select-option>
                    <a-select-option value="7">7</a-select-option>
                    <a-select-option value="8">8</a-select-option>
                    <a-select-option value="9">9</a-select-option>
                    <a-select-option value="10">10</a-select-option>
                    <a-select-option value="11">11</a-select-option>
                    <a-select-option value="12">12</a-select-option>
                    <a-select-option value="13">13</a-select-option>
                    <a-select-option value="14">14</a-select-option>
                    <a-select-option value="15">15</a-select-option>
                    <a-select-option value="16">16</a-select-option>
                    <a-select-option value="17">17</a-select-option>
                    <a-select-option value="18">18</a-select-option>
                    <a-select-option value="19">19</a-select-option>
                    <a-select-option value="20">20</a-select-option>
                    <a-select-option value="21">21</a-select-option>
                    <a-select-option value="22">22</a-select-option>
                    <a-select-option value="23">23</a-select-option>
                    <a-select-option value="24">24</a-select-option>
                    <a-select-option value="25">25</a-select-option>
                    <a-select-option value="26">26</a-select-option>
                    <a-select-option value="27">27</a-select-option>
                    <a-select-option value="28">28</a-select-option>
                    <a-select-option value="29">29</a-select-option>
                    <a-select-option value="30">30</a-select-option>
                    <a-select-option value="31">31</a-select-option>
                    <a-select-option value="32">32</a-select-option>
                    <a-select-option value="33">33</a-select-option>
                    <a-select-option value="34">34</a-select-option>
                    <a-select-option value="35">35</a-select-option>
                    <a-select-option value="36">36</a-select-option>
                    <a-select-option value="37">37</a-select-option>
                    <a-select-option value="38">38</a-select-option>
                    <a-select-option value="39">39</a-select-option>
                    <a-select-option value="40">40</a-select-option>
                    <a-select-option value="41">41</a-select-option>
                    <a-select-option value="42">42</a-select-option>
                    <a-select-option value="43">43</a-select-option>
                    <a-select-option value="44">44</a-select-option>
                    <a-select-option value="45">45</a-select-option>
                    <a-select-option value="46">46</a-select-option>
                    <a-select-option value="47">47</a-select-option>
                    <a-select-option value="48">48</a-select-option>
                    <a-select-option value="49">49</a-select-option>
                    <a-select-option value="50">50</a-select-option>
                    <a-select-option value="51">51</a-select-option>
                    <a-select-option value="52">52</a-select-option>
                    <a-select-option value="53">53</a-select-option>
                    <a-select-option value="54">54</a-select-option>
                    <a-select-option value="55">55</a-select-option>
                    <a-select-option value="56">56</a-select-option>
                    <a-select-option value="57">57</a-select-option>
                    <a-select-option value="58">58</a-select-option>
                    <a-select-option value="59">59</a-select-option>
                </a-select>
                <label for="" class="font">秒</label>

                <a-button type="primary" @click="settime" style="margin-left:20px">设置时间</a-button>
            </a-card>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '收费时间间隔设置'},
            ],
            hour:"",
            minue:"",
            second:""

        }
    },
    mounted(){
        this.$axios.get('/api/cumtimesetinfo',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                this.hour=res.data.data.hour
                this.minue=res.data.data.minue
                this.second=res.data.data.second
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){
                this.$message.warning(res.data.msg); 
            }else{
                this.$message.warning(res.data.msg); 
            }
        })
    },
    methods:{
        changehouer(value){
            this.hour=value
        },
        changeminue(value){
            this.minue=value
        },
        changesecond(value){
            this.second=value
        },
        settime(){
            var params=new URLSearchParams()
            params.append('hour',this.hour)
            params.append('minue',this.minue)
            params.append('second',this.second)
            this.$axios.post('/api/setcumtime',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success("设置成功"); 
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/time.vue